import BaseService from "./baseService";
import userData from "../staticenv";

export function planDetail() {
    return BaseService.get("/planDetail", {
        // headers: {
        //     shop: userData.shop,
        //     accesstoken: userData.accessToken,
        // },
        
    });
}

export function previewOrderLink() {
    return BaseService.get("/previewOrderLink", {
        // headers: {
        //     shop: userData.shop,
        //     accesstoken: userData.accessToken,
        // },
        
    });
}

export function activeStatics() {
    return BaseService.get("/activeStatics", {
        // headers: {
        //     shop: userData.shop,
        //     accesstoken: userData.accessToken,
        // },
        
    });
}

export function premiumPlan() {
    return BaseService.post(
        "/premiumPlan",
        {},
        {
            headers: {
                shop: userData.shop,
                accesstoken: userData.accessToken,
            },
        }
    );
}

export function makeUserBasic() {
    return BaseService.post(
        "/makeUserBasic",
        {},
        {
            headers: {
                shop: userData.shop,
                accesstoken: userData.accessToken,
            },
        }
    );
}

export function customizeMsg(data) {
    return BaseService.post("/customizeMsg", data, {
        // headers: {
        //     shop: userData.shop,
        //     accesstoken: userData.accessToken,
        // },
        
    });
}

export function customizeMsg_Get() {
    return BaseService.get("/customizeMsg", {
        // headers: {
        //     shop: userData.shop,
        //     accesstoken: userData.accessToken,
        // },
        
    });
}

export function statusChange(data) {
    return BaseService.post(
        "/statusChange",
        { data },
        {
            headers: {
                shop: userData.shop,
                accesstoken: userData.accessToken,
            },
        }
    );
}
export function statusChange_load() {
    return BaseService.get("/statusChange", {
        // headers: {
        //     shop: userData.shop,
        //     accesstoken: userData.accessToken,
        // },
        
    });
}

export function getEnv() {
    return BaseService.get("/getEnv", {
        // headers: {
        //     shop: userData.shop,
        //     accesstoken: userData.accessToken,
        // },
        
    });
}
